import localForage from 'localforage'

import getRawData from './getRawData'

const PluginID = Symbol('LocalForage')

export const LocalForage = localStorageKey => {
  return () => ({
    id: PluginID,
    init: state => {
      const rawState = getRawData(state)
      localForage.getItem(localStorageKey).then(persisted => {
        if (persisted !== null) {
          state.set(persisted)
        } else if (!state.promised && !state.error) {
          localForage.setItem(localStorageKey, rawState)
        }
      })
      return {
        onSet: p => {
          if ('state' in p) {
            localForage.setItem(localStorageKey, p.state)
          } else {
            localForage.removeItem(localStorageKey)
          }
        }
      }
    }
  })
}
